import logging from '../logging';
import { ParametricPart, Section } from '../domain';
import { approxGreaterThan, approxLessThan, round2slot } from '../measurement';
import { clamp } from '../math/clamp';
import { overlapsGenericAsset, overlapsPartRange } from './overlapping';
import { slotAbove, slotBelow } from '../measurement';

const log = logging('parametricPartControllers');

/**
 * A comparator function for sorting parametric parts.
 */
export const partElevationAscending = (a: ParametricPart, b: ParametricPart) => {
    return a.position.y - b.position.y;
};

/**
 * We want a simpler implementation than what we can get from the version of
 * this function in ./overlapping.ts, which was built for detecting overlaps
 * between drawers.
 */
const overlapsDrawer = (
    section: Section,
    y: number ) =>
{
    for(let drawer of section.drawers) {
        if(approxGreaterThan(y, drawer.position.y)
           && approxLessThan(y, drawer.position.y + drawer.height))
        {
            return true;
        }
    }
    return false;
}


/**
 * Moves a parametric part constrained within the bounds of its parent section.
 * @param part The parametric part model to move
 * @param y The absolute elevation in inches that the part should be moved to,
 * i.e. the screen position of the mouse converted to an elevation measure.
 */
export const moveParametricPart = (part: ParametricPart, y: number) => {
    const
        parent = part.parent as Section,
        origin = parent.position.y,
        min = slotAbove(origin),
        max = slotBelow(origin + parent.height),

        slot = clamp(round2slot(y), min, max);

    if(overlapsPartRange(parent, slot, part.height || 32/25.4, part)) {
        // do nothing
    }
    else if(overlapsDrawer(parent, slot)) {
        // also do nothing
    }
    else if(overlapsGenericAsset(parent, slot, part.height || 32/25.4)) {
        // probably sensing a pattern here
    }
    // Otherwise we have no obstructions, so feel free!
    else {
        part.position.y = slot;
    }
}
